/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BelongsToCompany
 */
export interface BelongsToCompany {
    /**
     * 
     * @type {boolean}
     * @memberof BelongsToCompany
     */
    hasAccess?: boolean;
}

/**
 * Check if a given object implements the BelongsToCompany interface.
 */
export function instanceOfBelongsToCompany(value: object): value is BelongsToCompany {
    return true;
}

export function BelongsToCompanyFromJSON(json: any): BelongsToCompany {
    return BelongsToCompanyFromJSONTyped(json, false);
}

export function BelongsToCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BelongsToCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'hasAccess': json['hasAccess'] == null ? undefined : json['hasAccess'],
    };
}

export function BelongsToCompanyToJSON(value?: BelongsToCompany | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hasAccess': value['hasAccess'],
    };
}

